import { useDocumentTitle } from '@hooks/index';
import React from 'react';
import { useTranslate } from '@translations/useTranslate';
import { useParams } from 'react-router-dom';
import { SurveyForm } from '@ui/components/organisms';
import { useGetSurveyLookups } from '@services/Survey';

export const Survey: React.FC = () => {
  const { t } = useTranslate();
  useDocumentTitle(t('page.title.survey'));
  const { id } = useParams<{ id: string }>();
  const [currentPage, setCurrentPage] = React.useState(1);
  const changeCurrentPage = React.useCallback((page) => {
    setCurrentPage(page);
  }, []);
  const { data: lookups, isLoading: isLookupsLoading } = useGetSurveyLookups(id);

  if (currentPage === 2) {
    return (
      <>
        <h2 className="w-100 text-center fw-bold pt-2 pb-3">{t('survey.from.completed.title')}</h2>
        <p className="text-secondary mb-3 fs-6 lh-base mx-auto" style={{ maxWidth: '70%' }}>
          {t('survey.from.completed.message')}
        </p>
      </>
    );
  }
  return lookups && !isLookupsLoading ? (
    <>
      <h2 className="w-100 text-center fw-bold pt-2 pb-3">{t('survey.form.title')}</h2>
      {lookups.status === 'SUBMITTED' ? (
        <p
          className="text-secondary mb-3 fs-6 lh-base mx-auto text-center"
          style={{ maxWidth: '70%' }}
        >
          {t('survey.from.status.message')}
        </p>
      ) : (
        <>
          <p
            className="text-secondary mb-3 fs-6 lh-base mx-auto text-center"
            style={{ maxWidth: '70%' }}
          >
            {t('survey.from.message')}
          </p>

          <div
            className="w-100 d-flex justify-content-between mb-4 fw-semibold mx-auto"
            style={{ maxWidth: '63%' }}
          >
            <span>
              <span className="fw-bold">{t('survey.form.service.name')}</span> {lookups.serviceName}
            </span>
            <span>
              <span className="fw-bold">{t('survey.form.request.id')}</span> {lookups.requestId}
            </span>
          </div>
          <SurveyForm
            lookups={lookups}
            requestId={id}
            onRequestSuccess={() => {
              changeCurrentPage(2);
            }}
          />
        </>
      )}
    </>
  ) : (
    <></>
  );
};
